<template>
  <WdsSegmentedControl
    :default-active-key="store.paymentRequestType"
    full-width
    :options="paymentRequestTypeOptions"
    @click="updatePaymentRequestType"
  />
</template>

<script setup lang="ts">
import { WdsSegmentedControl } from '@worksome/wds-components'
import { computed } from 'vue'
import { PaymentRequestTypeEnum } from '@/components/PaymentRequest/enums'
import { useTranslation } from '@/composables/translation'
import { usePaymentRequestStore } from '@/components/PaymentRequest/store/usePaymentRequestStore'
import { RateType } from '@/enums'
import { useTimesheetStore } from '@/components/PaymentRequest/store/useTimesheetStore'

const { $t } = useTranslation()
const store = usePaymentRequestStore()
const timesheetsStore = useTimesheetStore()

const props = defineProps<{
  allowSpecifyAmountPaymentRequests?: boolean
}>()

const paymentRequestTypeOptions = computed(() => {
  const options = [
    {
      optionKey: PaymentRequestTypeEnum.TIME_X_RATE,
      title: $t('Time x Rate'),
      icon: 'calendar',
    },
  ]

  if (props.allowSpecifyAmountPaymentRequests) {
    options.push({
      optionKey: PaymentRequestTypeEnum.SPECIFY_AMOUNT,
      title: $t('Specify Amount'),
      icon: 'currency',
    })
  }

  return options
})

const updatePaymentRequestType = (newPaymentRequestType: PaymentRequestTypeEnum) => {
  // Adjust the rates based on the payment request type
  if (newPaymentRequestType === PaymentRequestTypeEnum.SPECIFY_AMOUNT) {
    store.paymentRequestRate.rateType = RateType.FIXED
  } else {
    store.paymentRequestRate.rate = store.hireRate.rate
    store.paymentRequestRate.rateType = store.hireRate.rateType
  }
  store.updatePaymentRequestType(newPaymentRequestType)
  timesheetsStore.resetTimesheetOptions()
}
</script>
